import {isString, some} from "lodash"

/**
 * Checks if string has spaces or not
 * @param {*} Just pass the string.
 * @returns {*} Returns a boolean, TRUE if the string has spaces, FALSE if it doesn't.
 * @returns {*} Returns the value if its not a string.
 */

const whitespaceCharacters = [
  " ",
  "  ",
  "\b",
  "\t",
  "\n",
  "\v",
  "\f",
  "\r",
  '"',
  "\\",
  "\u0008",
  "\u0009",
  "\u000A",
  "\u000B",
  "\u000C",
  "\u000D",
  "\u0020",
  "\u0022",
  "\u0027",
  "\u005C",
  "\u00A0",
  "\u2028",
  "\u2029",
  "\uFEFF"
]

export const hasWhitespace = ({value = ""}) => {
  if (!isString(value)) {
    return value
  }

  return some(whitespaceCharacters, (w) => value.indexOf(w) > -1)
}
